/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAccordion from 'base/components/standalone/Accordion';

export const DynamicStandaloneAccordion = StandaloneAccordion;
export type DynamicStandaloneAccordionProps = PropsFromComponent<typeof StandaloneAccordion>;

export const DynamicStandaloneAccordionWith = (extras: DynamicStandaloneExtras): typeof StandaloneAccordion => {
    return function DynamicStandaloneAccordion(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Accordion');
        return <StandaloneAccordion {...mergeProps({ options: { theme } }, props)} />;
    }
}